/* src/app/app.component.scss */
::ng-deep .nav-menu-item {
  --dot-size: 0.7rem;
  position: relative;
}
::ng-deep .nav-menu-item .badge {
  position: absolute;
  top: 2rem;
  left: 3.4rem;
  border-radius: var(--dot-size);
  color: var(--sdds-white);
  font-weight: bold;
  min-width: var(--dot-size);
  min-height: var(--dot-size);
  width: auto;
  height: auto;
  padding: 0;
  z-index: 1002 !important;
}
::ng-deep .nav-menu-item.highlighted .badge {
  visibility: visible;
}
::ng-deep .nav-menu-item .badge-count {
  top: 1.4rem;
  left: 2.8rem;
  line-height: var(--dot-size);
  padding: 4px;
}
::ng-deep .nav-menu-item.danger .badge {
  background: var(--tds-negative) !important;
}
::ng-deep .nav-menu-item.default .badge {
  background: var(--tds-grey-600) !important;
}
::ng-deep .nav-menu-item.info .badge {
  background: var(--tds-information) !important;
}
::ng-deep .nav-menu-item.success .badge {
  background: var(--tds-positive) !important;
}
::ng-deep .nav-menu-item.warning .badge {
  background: var(--tds-warning) !important;
}
::ng-deep .nav-menu-item.primary .badge {
  background: var(--tds-blue-600) !important;
}
span.new-updates-badge {
  margin-left: 2rem;
  background: var(--tds-blue-400);
  padding: 0.4rem 0.8rem;
  border-radius: 2rem;
  font: var(--tds-detail-05);
}
.nav-menu-item.preloader {
  cursor: default;
}
.nav-menu-item.preloader loader {
  opacity: 0.6;
}
.nav-menu-item.preloader ::ng-deep li.sss-navbar__list-group-item {
  cursor: default;
}
.nav-menu-item.preloader ::ng-deep li.sss-navbar__list-group-item span.menu-item-label {
  display: none !important;
}
.cookie-wrapper {
  position: fixed;
  bottom: 2.4rem;
  right: 8rem;
  transition: left 0.2s ease, transform 0.2s ease;
  z-index: 9999;
  pointer-events: auto;
}
@media (max-width: 575px) {
  .cookie-wrapper {
    bottom: 6.5rem;
    right: 2rem;
  }
}
.cookie-wrapper {
}
.cookie-wrapper::ng-deep .sc-tds-button.sc-tds-button-s.sm {
  height: 3.6rem;
  width: 4.4rem;
  justify-content: center;
}
/*# sourceMappingURL=app.component.css.map */
